import { QuestionCircleIcon, SettingsIcon } from '@mm/icons';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import classnames from 'classnames';
import React, { MouseEventHandler, useMemo } from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { HELP_BETA } from '../../../../common/constants/externalRoutes';
import * as routes from '../../../../common/constants/routes';
import { colors } from '../../../../editor/features/beta/styles/colors';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { WhatsNewLink } from '../../WhatsNewLink/WhatsNewLink';

interface Props {
  className?: string;
  onClick?: MouseEventHandler;
}

export const SidebarMenuIconActions = ({ className, onClick }: Props) => {
  const chatbot = useSelector(activeChatbotSelector);
  const activeFacebookPage = useSelector(activeFacebookPageSelector);
  const onlyMaintenance =
    activeFacebookPage &&
    !activeFacebookPage.subscription &&
    !activeFacebookPage.redemption;

  const { history, location } = useRouter();
  const { pathname } = location;

  const onSettingsClick = () => {
    history.push(
      onlyMaintenance
        ? routes.SETTINGS_MAINTENANCE(chatbot.id)
        : routes.CHATBOT_EDITOR_SETTINGS(chatbot.id),
    );
  };

  const settingsIconColor = useMemo(() => {
    const isActiveSettingsPage =
      pathname.indexOf(routes.CHATBOT_EDITOR_SETTINGS(chatbot.id)) > -1;
    return isActiveSettingsPage ? colors.accentBlue : colors.palePurple;
  }, [chatbot.id, pathname]);

  return (
    <div
      className={classnames('sidebar-header__action_icons', className)}
      onClick={onClick}
    >
      <SettingsIcon
        onClick={onSettingsClick}
        className="sidebar-header__settings_icon"
        color={settingsIconColor}
      />
      <WhatsNewLink />
      <a
        className="sidebar-header__question_link"
        href={HELP_BETA}
        target="_blank"
      >
        <QuestionCircleIcon color={colors.palePurple} />
      </a>
    </div>
  );
};
